<template>
  <layout-main-with-small-sidebar>
    <template #default>
      <div>
        <div class="flex-column flex-middle margin-2xl-bottom">
          <h2>{{ tt("justopp.userRegistration.registerAs") }}</h2>
          <div
            v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
            class="animate--delay-100 gap-l flex-center flex-middle l:flex-row l:flex-start hide">
            <div class="relative">
              <form-button theme="lead" size="large" class="selected-button"
                >{{ t("justopp.userRegistration.asBuyer") }}
              </form-button>
            </div>
            <saffron-link :to="{ name: 'vendor-register' }" class="plain-link">
              <form-button
                v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
                class="animate--delay-200 gap-l flex-center flex-middle l:flex-row l:flex-start hide"
                theme="lead-inverse"
                size="large"
                >{{ t("justopp.userRegistration.asSeller") }}
              </form-button>
            </saffron-link>
          </div>
        </div>
        <div>
          <base-form
            autocomplete="off"
            v-model="registrationData"
            action="/user/register"
            method="post"
            theme-style="minimal"
            class="width-expand"
            :config="formConfig"
            @form:submit-success="registrationSuccessHandler"></base-form>
        </div>
      </div>
    </template>

    <template #sidebar="{ sidebarClass, addSidebarClass, removeSidebarClass }">
      <fancy-title
        v-for="i of 3"
        align="start"
        size="small"
        icon="check"
        :title="`justopp.userRegistration.features.feature${i}Title`"
        :content="`justopp.userRegistration.features.feature${i}Content`"></fancy-title>
      <div
        class="flex-start margin-bottom flex-middle flex-center flex-column gap-s"
        style="margin-top: auto">
        <img
          class="margin-m-bottom"
          style="width: 100%; flex: 0 0 100%"
          :src="getDynamicAssetUrl('images/logos/logo-with-text-dark.svg')"
          alt="logo" />
      </div>
    </template>
  </layout-main-with-small-sidebar>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";

export default {
  layout: {
    component: "default",
    params: {
      title: "justopp.userRegistration.pageTitle",
      subTitle: "justopp.userRegistration.pageSubtitle",
      containerClass: "margin-remove-vertical",
    },
  },
  middleware: {
    hasNoInactiveRegistration: {},
  },
  props: {
    empty: {
      type: String,
      default: "0",
    },
    redirect: {
      type: [Object, String],
      default: { name: "index" },
    },
  },
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "justopp.userRegistration.browserTitle",
  data() {
    let tosText1 = this.translateUcFirst("justopp.userRegistration.fields.agreesTo");
    let tosText2 = this.translateUcFirst("justopp.userRegistration.fields.tosLinkCta");
    let randomSeed = Date.now();

    let registrationData = {
      fullName: "Test Client",
      personalPhoneNumber: { prefix: "+44", number: u.getRandomDigits(9) },
      personalEmail: `test${randomSeed}@test.com`,
      position: "CEO",
      fullName2: "Test Client",
      personalPhoneNumber2: { prefix: "+33", number: u.getRandomDigits(9) },
      personalEmail2: `test${randomSeed}@test.com`,
      position2: "CTO",
      companyName: "Some company inc.",
      country: "DE",
      city: "Munich",
      address: "Some str 224th new york",
      interestedIn: [],
      website: "https://google.com",
      companyId: "aa-12332",
      email: "test123-" + new Date().getTime() + "@gmail.com",
      password: "12345678",
      agreesToTos: true,
      firstName: "test1",
      lastName: "test2",
    };
    if (!config.justopp.user.devRegistrationData) {
      registrationData = {};
    }
    registrationData = {};
    return {
      registrationData: registrationData, //{}, //registrationData, // registrationData,
      formConfig: {
        formHandling: {
          preflight: [
            {
              type: "validation",
              options: {},
            },
            {
              type: "submitDataMutation",
              options: {
                handler: async ({ next, fulfil, reject, data }) => {
                  data.personalPhoneNumber =
                    data.personalPhoneNumber.prefix + data.personalPhoneNumber.number;

                  if (
                    typeof data.personalPhoneNumber2 === "object" &&
                    data.personalPhoneNumber2
                  ) {
                    data.personalPhoneNumber2 =
                      data.personalPhoneNumber2.prefix + data.personalPhoneNumber2.number;
                  }

                  data.fullName = data.firstName + " " + data.lastName;

                  next();
                },
              },
            },
          ],
        },
        fields: {
          firstName: {
            name: "firstName",
            type: "text",
            placeholder: "justopp.userRegistration.fields.firstName",
            icon: "user",
            group: "contactDetails",
            validation: {
              required: {},
            },
          },
          lastName: {
            name: "lastName",
            type: "text",
            placeholder: "justopp.userRegistration.fields.lastName",
            icon: "user",
            group: "contactDetails",
            validation: {
              required: {},
            },
          },
          personalEmail: {
            name: "personalEmail",
            type: "email",
            placeholder: "justopp.userRegistration.fields.personalEmail",
            icon: "mail",
            group: "contactDetails",
            autocomplete: "off",
            validation: {
              required: {},
              minLength: {
                params: {
                  min: 4,
                },
              },
            },
          },
          personalPhoneNumber: {
            name: "personalPhoneNumber",
            type: "i18nPhoneNumber",
            placeholder: "justopp.userRegistration.fields.personalPhoneNumber",
            icon: "iphone",
            group: "contactDetails",
            validation: {
              required: {},
              i18nPhoneNumberObject: {},
              uniqueValue: {
                params: {
                  type: "user",
                  key: "phoneNumber",
                  valueParser: async (val) => {
                    if (val && typeof val === "object") {
                      return val.prefix + val.number;
                    }
                    return val;
                  },
                },
              },
            },
          },
          position: {
            name: "position",
            type: "text",
            placeholder: "justopp.userRegistration.fields.position",
            icon: "shield-check",
            group: "contactDetails",
            validation: {
              minLength: {
                params: {
                  min: 2,
                },
              },
            },
          },
          fullName2: {
            name: "fullName2",
            type: "text",
            placeholder: "justopp.userRegistration.fields.fullName2",
            icon: "user",
            group: "contactDetails2",
            validation: {
              minLength: {
                params: {
                  min: 4,
                },
              },
            },
          },
          personalEmail2: {
            name: "personalEmail2",
            type: "tel",
            placeholder: "justopp.userRegistration.fields.personalEmail2",
            icon: "iphone",
            group: "contactDetails2",
            validation: {
              minLength: {
                params: {
                  min: 4,
                },
              },
            },
          },
          personalPhoneNumber2: {
            name: "personalPhoneNumber2",
            type: "i18nPhoneNumber",
            placeholder: "justopp.userRegistration.fields.personalPhoneNumber2",
            icon: "iphone",
            group: "contactDetails2",
            validation: {
              // required: {},
              //  i18nPhoneNumberObject: {},
            },
          },
          position2: {
            name: "position2",
            type: "text",
            placeholder: "justopp.userRegistration.fields.position2",
            icon: "shield-check",
            group: "contactDetails2",
            validation: {
              minLength: {
                params: {
                  min: 2,
                },
              },
            },
          },
          companyName: {
            name: "companyName",
            type: "text",
            placeholder: "justopp.userRegistration.fields.companyName",
            icon: "cube",
            group: "companyDetails",
            validation: {
              required: {},
              minLength: {
                params: {
                  min: 4,
                },
              },
            },
          },
          country: {
            name: "country",
            type: "countryList",
            placeholder: "justopp.userRegistration.fields.country",
            icon: "flag",
            translateList: false,
            group: "companyDetails",
            validation: {
              required: {},
              minLength: {
                params: {
                  min: 2,
                },
              },
            },
          },
          address: {
            name: "address",
            type: "text",
            placeholder: "justopp.userRegistration.fields.address",
            icon: "map-pin-location",
            group: "companyDetails",
            validation: {
              minLength: {
                params: {
                  min: 4,
                },
              },
            },
          },
          city: {
            name: "city",
            type: "text",
            placeholder: "justopp.userRegistration.fields.city",
            icon: "map-pin-location",
            group: "companyDetails",
            validation: {
              minLength: {
                params: {
                  min: 2,
                },
              },
            },
          },
          interestedIn: {
            name: "interestedIn",
            type: "select2",
            placeholder: "justopp.userRegistration.fields.interestedIn",
            icon: "thumbs-up",
            itemComponent: "iconItem",
            asyncListSource: "justopp/deals/category",
            asyncListLive: false,
            showFilterField: false,
            // textFilterAsSaffronListFilter: true,
            // asyncDataTextFilterParamName: "name",
            multiple: true,
            asyncListData: {
              simplified: true,
            },

            group: "companyDetails",

            validation: {},
          },
          website: {
            name: "website",
            type: "text",
            placeholder: "justopp.userRegistration.fields.website",
            group: "companyDetails",
            icon: "link",
            validation: {
              minLength: {
                params: {
                  min: 10,
                },
              },
            },
          },
          companyId: {
            name: "companyId",
            type: "text",
            placeholder: "justopp.userRegistration.fields.companyId",
            group: "companyDetails",
            icon: "clipboard-check",
            validation: {
              required: {},
              minLength: {
                params: {
                  min: 3,
                },
              },
            },
          },
          email: {
            name: "email",
            type: "email",
            placeholder: "justopp.userRegistration.fields.email",
            group: "credentials",
            icon: "mail",
            autocomplete: false,
            validation: {
              required: {},
              email: {},
              uniqueValue: {
                params: {
                  type: "user",
                  key: "email",
                },
              },
            },
          },
          password: {
            name: "password",
            type: "password",
            placeholder: "justopp.userRegistration.fields.password",
            icon: "lock",
            group: "credentials",
            autocomplete: "off",
            validation: {
              required: {},
              minLength: {
                params: {
                  min: 6,
                },
              },
            },
          },
          agreesToTos: {
            name: "agreesToTos",
            type: "checkbox",
            label: `<span>${tosText1} <a href="#content/article/terms-of-service" target="_blank">${tosText2}</a></span>`,
            htmlLabel: true,
            group: "credentials",
            class: "width-expand",
            wrapperStyle: "flex: 0 0 100%!important;",
            validation: {
              required: {},
            },
          },
        },
        groups: {
          companyDetails: {
            component: "form-field-set",
            props: {
              icon: "cube",
              title: "justopp.userRegistration.fieldsets.companyDetails",
              class: "form__fieldset--plain",
              maxFieldsPerRow: 2,
            },
          },
          contactDetails: {
            component: "form-field-set",
            props: {
              icon: "user",
              title: "justopp.userRegistration.fieldsets.contactDetails",
              class: "form__fieldset--plain ",
              maxFieldsPerRow: 2,
            },
          },
          contactDetails2: {
            component: "form-field-set",
            props: {
              icon: "user",
              title: "justopp.userRegistration.fieldsets.contactDetails2",
              class: "form__fieldset--plain ",
              maxFieldsPerRow: 2,
            },
          },
          credentials: {
            component: "form-field-set",
            props: {
              icon: "lock",
              title: "justopp.userRegistration.fieldsets.credentials",
              class: "form__fieldset--plain margin-bottom-remove",
              maxFieldsPerRow: 2,
            },
          },
          legal: {
            component: "block",
          },
        },
        buttons: {
          submit: {
            text: "justopp.userRegistration.formButtons.submit",
            class: "width-expand",
          },
        },
        //
      },
    };
  },
  computed: {},
  watch: {
    registrationData: {
      handler(newVal) {
        if (newVal.personalEmail && newVal.personalEmail != "") {
          newVal.email = newVal.personalEmail;
        }
      },
      deep: true,
    },
  },
  methods: {
    async loginByState() {
      const loginUrl = "token/refresh/userPassword";
      const loginPayload = {
        email: this.registrationData.email,
        password: this.registrationData.password,
      };

      const loginResult = await this.asyncOps.asyncCall(loginUrl, loginPayload, {
        method: "post",
      });

      if (loginResult.isError) {
        if (loginResult.code === 403 && loginResult.data === 412) {
          this.$store.commit("user/setHasInactiveRegistration", true);
          this.$router.push({ name: "user-activation" });
          this.$s.ui.notification(
            "justopp.userRegistration.activationRequiredNotification",
            "success"
          );
          return true;
        }

        this.$s.ui.notification(
          "justopp.userRegistration.registrationLoginError",
          "error"
        );
        return;
      }
      const loginResultData = loginResult.data;
      this.$store.commit("user/setToken", loginResultData.jwt);
      this.$store.commit("user/setRefreshToken", loginResultData.refreshToken);

      this.$store.commit(
        "user/setRefreshTokenExpires",
        loginResultData.refreshTokenExpires
      );

      let result = await this.$store.dispatch("user/updateUserProfile");

      if (!result) {
        this.$s.ui.notification(
          "justopp.userRegistration.registrationLoginError",
          "error"
        );
        return;
      }

      this.$s.ui.notification(
        "justopp.userRegistration.registrationFinalSuccessNotification",
        "success"
      );

      this.$router.push(this.getLoginRedirectRedirect());
    },
    getLoginRedirectRedirect() {
      let profile = this.$store.getters["user/profile"];

      // should never happen, but lets be safe anyway
      if (!profile) {
        return { path: "/" };
      }

      // we got a redirect in the query
      if (
        this.$router.currentRoute.value.query &&
        this.$router.currentRoute.value.query.redirect
      ) {
        console.log("redirect with redirect");
        return { name: this.$router.currentRoute.value.query.redirect };
      }

      if (
        this.$router.currentRoute.value.query &&
        this.$router.currentRoute.value.query.redirectUrl
      ) {
        console.log("redirect with loginRedirect");
        return { path: this.$router.currentRoute.value.query.redirectUrl };
      }

      if (profile.Vendor) {
        return {
          name: "company-vendorId-dashboard",
          params: { vendorId: profile.Vendor.id },
        };
      }

      return { path: "/" };
    },
    registrationSuccessHandler(res) {
      this.$s.ui.notification(
        "justopp.userRegistration.registerSuccessNotificationContent",
        "alt",
        {
          icon: "check",
          title: "justopp.userRegistration.registerSuccessNotificationTitle",
        }
      );
      this.loginByState();
    },
  },
};
</script>

<style lang="scss" scoped>
.selected-button {
  &:hover {
    background-color: var(--c-lead) !important;
    color: var(--c-text) !important;
    border-color: var(--c-lead) !important;
    cursor: default;
    box-shadow: var(--box-shadow-1);
  }

  &::after {
    content: " ";
    position: absolute;
    width: 85%;
    height: 3px;
    background-color: var(--c-lead);
    top: calc(100% + var(--margin-m));
  }
}
</style>
